import { useRsrc } from '@/common/rsrc/RsrcContext';
import { createContext, useContext, useEffect, useState } from 'react';

const DashboardDataContext = createContext({});

/**
 * Fetches data once and shares it with every DashboardCard inside it that has no plugin of its own. Use it when
 * several cards show the same data, so the cards don't each fetch it.
 *
 * Each card still registers itself with the chatbot under its own title, using this provider's fetch params, so the
 * chatbot sees every card the user sees and can fetch the same data they show.
 *
 * children is a function of the data (undefined until it arrives), so the caller can lay out its cards based on it.
 */
export const DashboardDataProvider = ({ module, plugin, reqParam, children }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    rsrc.data(module, plugin, reqParam).then((res) => {
      setData(res);
    });
  }, [reqParam]);

  const dataFetchParams = reqParam && { data: { module, plugin, reqParam } };

  return (
    <DashboardDataContext.Provider value={{ data, dataFetchParams }}>{children(data)}</DashboardDataContext.Provider>
  );
};

export const useDashboardData = () => useContext(DashboardDataContext);
